import axiosBaseApi from '@/services/common/lib/axiosBaseApi';
import { SortTransaction } from '@/services/transactions/TransactionTypes';

export const getTransactions = async (skip: number, take: number, sort: SortTransaction) => {
  const encodedSort = encodeURIComponent(JSON.stringify(sort));

  return await axiosBaseApi.get(`/v1/transactions?skip=${skip}&take=${take}&sort=${encodedSort}`);
};
